module.exports = __webpack_public_path__ + "static/media/StackedBar.962783db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/assets/StackedBar.svg
// module id = 288
// module chunks = 0